//Accept only numbers in an input

export const onlyNumbers = (value: string) => {
  const parsed = parseInt(value.replace('/[^]/g', ''));
  return isNaN(parsed) ? '' : parsed.toString();
};
